(() => {
      const blockedFormSelector = 'form.go417382439.klaviyo-form';

      const removeBlockedForm = (form) => {
        if (!form || !form.matches?.(blockedFormSelector)) return;

        const dialog = form.closest('[role="dialog"], dialog, [aria-modal="true"]');
        const closeButton = dialog?.querySelector(
          'button[aria-label*="close" i], button[title*="close" i]'
        );

        if (closeButton) {
          closeButton.click();
          return;
        }

        let removable = dialog || form;
        for (let parent = removable.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
          if (getComputedStyle(parent).position === 'fixed') removable = parent;
        }

        removable.remove();
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
      };

      const inspectRoot = (root) => {
        if (!root) return;
        if (root.matches?.(blockedFormSelector)) removeBlockedForm(root);
        root.querySelectorAll?.(blockedFormSelector).forEach(removeBlockedForm);
      };

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) inspectRoot(node);
          }
        }
      });

      observer.observe(document.documentElement, { childList: true, subtree: true });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => inspectRoot(document), { once: true });
      } else {
        inspectRoot(document);
      }
    })();


(() => {
  if (window.__r1ContactTrackingInstalled) return;
  window.__r1ContactTrackingInstalled = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  const sendR1Event = (name, params = {}) => {
    window.gtag('event', name, params);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const params = {
      link_url: href,
      link_text: (link.textContent || '').trim().slice(0, 120),
      page_path: window.location.pathname
    };

    if (href.startsWith('tel:')) {
      sendR1Event('click_to_call', params);
      return;
    }

    if (href.startsWith('sms:')) {
      const isRepairContact =
        href.includes('4355009755') ||
        href.includes('435-500-9755') ||
        document.querySelector('[data-r1-customer-help="service-writer"]');

      if (isRepairContact) {
        sendR1Event('r1_repair_text_initiated', params);
      }
    }
  }, true);
})();


(() => {
  const initR1RepairWebsiteCallTracking = () => {
    const isRepairPage =
      document.querySelector('[data-r1-customer-help="service-writer"]') ||
      document.querySelector('iframe[src*="shopmonkey.cloud/public/quote-request/6462a3f0c3847100264c7701"]');

    if (!isRepairPage) return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('config', 'AW-726913576/cBfxCIrLpIAdEKikz9oC', {
      phone_conversion_number: '801-899-2520'
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initR1RepairWebsiteCallTracking, { once: true });
  } else {
    initR1RepairWebsiteCallTracking();
  }
})();
